import React from 'react'

function ImportRtfFile({ onSuccess, onError, label = 'Importar' }) {
  // Vars
  const inputFileRef = React.createRef()

  // Events
  const onInputFileChange = async evt => {
    try {
      const fileList = evt.target.files
      if (fileList.length === 0) throw new Error('Nenhum arquivo foi selecionado')
      if (!allFilesAreRtfOrDoc(fileList))
        throw new Error('Somente arquivos RTF ou DOC são permitidos')

      const contents = await getFilesContents(fileList)
      onSuccess(contents)
    } catch (e) {
      onError(e)
    }
  }
  const onBtnImportarClick = () => {
    inputFileRef.current.click()
  }

  // Helper
  const allFilesAreRtfOrDoc = fileList => {
    for (const file of fileList) {
      const fileName = file.name.toLowerCase()
      if (!fileName.endsWith('.rtf') && !fileName.endsWith('.doc')) return false
    }
    return true
  }

  const getFilesContents = fileList => {
    const filesContent = []

    for (const file of fileList) {
      filesContent.push(getFileContent(file))
    }

    return Promise.all(filesContent)
  }

  const getFileContent = file => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          resolve(reader.result)
        })
        reader.readAsText(file)
      } catch (e) {
        reject(e)
      }
    })
  }

  // Render
  return (
    <div>
      <input
        type="file"
        accept=".rtf,.doc,application/rtf,text/rtf,application/msword"
        multiple
        onChange={onInputFileChange}
        ref={inputFileRef}
        style={{ display: 'none' }}
      />
      <button className="btnImportar" onClick={onBtnImportarClick}>
        {label}
      </button>
    </div>
  )
}

export default ImportRtfFile
